import { Component } from '@angular/core';

@Component({
  selector: 'app-sintered-metal-part',
  templateUrl: './sintered-metal-part.component.html',
  styleUrls: ['./sintered-metal-part.component.scss']
})
export class SinteredMetalPartComponent {
  advanceMoullding:any[] = [
    {
      title: 'Compaction Process​​',
      img: 'assets/images/capability/white/sintered_metal_1.JPG',
    },
    {
      title: 'Sizing Process​',
      img: 'assets/images/capability/white/sintered_metal_2.JPG',
    },
    {
      title: 'Secondary Machining',
      img: 'assets/images/capability/white/sintered_metal_3.JPG',
    },
    {
      title: 'Sintering Process​',
      img: 'assets/images/capability/white/sintered_metal_4.JPG',
    },
    {
      title: 'Secondary Treatment',
      img: 'assets/images/capability/white/sintered_metal_5.JPG',
    },
    // {
    //   title: 'Plastic To Rubber Bonding​',
    //   img: 'assets/images/placeholder.jpg',
    // }
  ]
  produtData:any[] = [
    {
      title: 'Fixed Timing Parts',
      img: 'assets/images/capability/white/sintered_metal_6.JPG',
    },
    {
      title: 'Variable Timing Parts​​',
      img: 'assets/images/capability/white/sintered_metal_7.JPG',
    },
    {
      title: 'Transmission Parts​',
      img: 'assets/images/capability/white/sintered_metal_8.JPG',
    },
    {
      title: 'Shock Absorber Parts​​​',
      img: 'assets/images/capability/white/sintered_metal_9.JPG',
    },
    {
      title: 'Structural Parts',
      img: 'assets/images/capability/white/sintered_metal_10.JPG',
    },
    {
      title: 'Pump Parts​​',
      img: 'assets/images/capability/white/sintered_metal_11.JPG',
    }
  ]  
  materialExpertise:any[] = [
    { 'item': 'Powder Metallurgy'},
    // { 'item': 'ABS'},
    // { 'item': 'Nylon'},
    // { 'item': 'PC'},
    // { 'item': 'PBT'},
    // { 'item': 'PMMA'},
    // { 'item': 'Other Engineering Plastic'},
  ]
  sizeandprecision:any[] = [
    { 'item': 'Up to 1000 Tonne'}
  ]
  advancemouldingtechnique:any[] = [
     { 'item':'Presses ranging from 50 tonsto 1000 tons'},
     { 'item':'Multi level part forming capabilities'},
     { 'item':'Fully hydraulic, mechanical & hybrid presses'},
     { 'item':'CNC servo-controlled presses with error proofing'},
    //  { 'item':'Thermoforming'},
    //  { 'item':'Compression Moulding'}
  ]
  inhousetech:any[] = [
    { 'item':'24 inch mesh belt sintering furnace'},
    { 'item':'Sinter hardening feature'},
    { 'item':'SCADA controlled process parameters'},
    // { 'item':'Tool Manufacturing'},
    // { 'item':'Moulding'},
    // { 'item':'Prototyping'}
 ]

 sizing:any[] = [
  { 'item':'Sizing presses ranging from 80 tons to 1000 tons'},
  { 'item':'Multi level sizing capabilities'},
  // { 'item':'SCADA controlled process parameters'},
  // { 'item':'Tool Manufacturing'},
  // { 'item':'Moulding'},
  // { 'item':'Prototyping'}
]

secondary:any[] = [
  { 'item':'Induction hardening'},
  { 'item':'Steam Treatment'},
  { 'item':'Final Machining & Finishing'},
  // { 'item':'SCADA controlled process parameters'},
  // { 'item':'Tool Manufacturing'},
  // { 'item':'Moulding'},
  // { 'item':'Prototyping'}
]
}
